<template>
    <aside class="navbar navbar-vertical navbar-expand-lg navbar-dark">
        <div class="container-fluid">
            <h1 class="navbar-brand navbar-brand-autodark">
                <a href="/dashboard">MBx Admin</a>
            </h1>
            <div class="collapse navbar-collapse" id="navbar-menu">
                <ul class="navbar-nav pt-lg-3">
                    <li class="nav-item">
                        <router-link class="nav-link" :to="{ name: 'admin dashboard'}">
                            <span class="nav-link-icon d-md-none d-lg-inline-block">
                                <svg xmlns="http://www.w3.org/2000/svg" class="icon" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"></path><polyline points="5 12 3 12 12 3 21 12 19 12"></polyline><path d="M5 12v7a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-7"></path><path d="M9 21v-6a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v6"></path></svg>
                            </span>
                            <span class="nav-link-title">
                                Dashboard
                            </span>
                        </router-link>
                    </li>

                    <li class="nav-item" v-bind:class="{dropdown: item.children !== undefined}" v-for="item in menu">
                        <template v-if="item.children !== undefined">
                            <a class="nav-link dropdown-toggle" v-bind:class="{ show: item.toggle}" @click.prevent="toggleDropdown(item)" href="#" data-bs-toggle="dropdown" data-bs-auto-close="false" role="button" aria-expanded="false">
                                <span class="nav-link-icon d-md-none d-lg-inline-block" v-html="item.icon">
                                </span>
                                <span class="nav-link-title">
                                    {{item.title}}
                                </span>
                            </a>
                            <div class="dropdown-menu" v-bind:class="{ show: item.toggle}">
                                <div class="dropdown-menu-columns">
                                    <div class="dropdown-menu-column">
                                        <router-link class="dropdown-item" v-for="link in item.children" v-bind:class="{active: $route.name.startsWith(baseName(link.linkName))}" :to="{ name: link.linkName}">{{link.title}}</router-link>
                                    </div>
                                </div>
                            </div>
                        </template>
                        <router-link v-else class="nav-link" :to="{ name: item.linkName}">
                            <span v-if="item.icon" class="nav-link-icon d-md-none d-lg-inline-block" v-html="item.icon"></span>
                            <span class="nav-link-title">
                                {{item.title}}
                            </span>
                        </router-link>

                    </li>
                </ul>
            </div>            
        </div>
    </aside>
</template>
<script>
export default {
    data() {
        return {
            menu: [
                {
                    title: 'Multibrain',
                    toggle: false,
                    icon: '<svg xmlns="http://www.w3.org/2000/svg" class="icon" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"></path><path d="M12 17.75l-6.172 3.245l1.179 -6.873l-5 -4.867l6.9 -1l3.086 -6.253l3.086 6.253l6.9 1l-5 4.867l1.179 6.873z"></path></svg>',
                    children: [
                        {
                            title: 'Companies',
                            linkName: 'admin companies index',
                            active: false,
                        },
                        {
                            title: 'Domains',
                            linkName: 'admin domains index',
                            active: false,
                        },
                        {
                            title: 'Users',
                            linkName: 'admin users index',
                            active: false,
                        },
                        {
                            title: 'Categories',
                            linkName: 'admin categories index',
                            active: false,
                        },
                        {
                            title: 'Subategories',
                            linkName: 'admin subcategories index',
                            active: false,
                        },
                        {
                            title: 'Content',
                            linkName: 'admin content index',
                            active: false,
                        }
                    ]
                },
            ]
        };
    },

    mounted() {
        this.menu.forEach(item => {
            if (item.toggle !== undefined && item.children !== undefined) {
                item.children.forEach(link => {
                    if (this.baseName(this.$route.name) == this.baseName(link.linkName)) {
                        item.toggle = true;
                    }
                });
            }
        });
    },

    methods: {
        baseName(linkName) {
            return linkName.substring(0, linkName.lastIndexOf(" "));
        },
        toggleDropdown(item) {
            item.toggle = !item.toggle;
        }
    }
}
</script>